import { Model } from "./Model";
import { Item } from "./Item";
import { Contact } from "./Contact";
import $moment from "moment";
import { Contract } from "./Contract";

export class Procurement extends Model {
  static props = {
    id: { type: Number },
    contract_id: { type: Number },
    contact_id: { type: Number },
    contact: { type: Contact },
    contract: { type: Contract },
    ordered_at: { type: String },
    delivered_at: { type: String },
    scheduled_for: { type: String },
    name: { type: String, default: "" },
    type: { type: String },
    items: { type: Array, default: [] },
    po_num: { type: String },
    user_id: { type: Number },
    ordered_by: { type: String },
    price_quote: { type: String },
    note: { type: Object, default: { text: null } }
  };

  /**
   * @param parameters  Object
   */
  constructor(parameters) {
    super(Procurement.props, parameters);
  }

  mapParametersToModel(parameters, props) {
    super.mapParametersToModel(parameters, props);

    if (parameters.items) {
      this.items = parameters.items.map(i => new Item(i));
    }

    if (parameters.price_quote) {
      this.price_quote = JSON.parse(parameters.price_quote);
    } else {
      this.price_quote = [];
    }
  }

  get orderDate() {
    return this.ordered_at ? $moment(this.ordered_at).format("MM/DD/YYYY") : "";
  }

  get deliveryDate() {
    return this.scheduled_for
      ? $moment(this.scheduled_for).format("MM/DD/YYYY")
      : "";
  }

  get vendorName() {
    return this.contact ? this.contact.name : "";
  }

  get vendorCompanyName() {
    return this.contact && this.contact.company_name
      ? this.contact.company_name
      : "";
  }

  get vendorNameWithCompany() {
    if (this.vendorCompanyName) {
      return this.vendorName
        ? `${this.vendorCompanyName} - ${this.vendorName}`
        : this.vendorCompanyName;
    }
    return this.vendorName;
  }

  get projectName() {
    return this.contract && this.contract.project_name
      ? this.contract.project_name
      : "";
  }

  get contractName() {
    return this.contract ? this.contract.name : undefined;
  }

  get contractContactName() {
    return this.contract && this.contract.primary_contact
      ? this.contract.primary_contact.name
      : "";
  }

  get contractContactNameAndPlace() {
    return {
      name: this.contractContactName,
      place: this.contract ? this.contract.place : null
    };
  }

  get noteText() {
    return this.note && this.note.text ? this.note.text : "";
  }
}
